import { memo } from "react"

interface ToastProps {
    text: string
    colorScheme?: 'green' | 'red' | 'yellow' | 'blue' | 'gray'
}

const Toast: React.FC<ToastProps> = ({ text, colorScheme = 'gray' }) => {

    const colorSchemeClasses = {
        green: 'bg-green-500 text-white',
        red: 'bg-red-500 text-white',
        yellow: 'bg-yellow-500 text-black',
        blue: 'bg-blue-500 text-white',
        gray: 'bg-gray-500 text-white'
    }[colorScheme]

    return (
        <div className={`p-4 rounded shadow-lg w-fit ${colorSchemeClasses}`}>
            <p className="text-sm">{text}</p>
        </div>
    )

}

export default memo(Toast)

